// Clock component - shows local time for Rijnsburg (Europe/Amsterdam timezone)

let clockInterval: number | null = null

export function initClock(): void {
  const clockElement = document.getElementById('clock')
  if (!clockElement) return

  // Update immediately
  updateClock(clockElement)

  // Update every second
  clockInterval = window.setInterval(() => {
    updateClock(clockElement)
  }, 1000)
}

function updateClock(element: HTMLElement): void {
  const now = new Date()

  // Get time in Amsterdam timezone
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'Europe/Amsterdam',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }

  const timeString = now.toLocaleTimeString('en-GB', options)

  // Replace colons with colons to match design (or customize format)
  element.textContent = timeString
}

export function stopClock(): void {
  if (clockInterval) {
    clearInterval(clockInterval)
    clockInterval = null
  }
}
